import BaseApi from './base.api'
import ApiService from '@services/api.service'

export default {
    ...BaseApi,
    ...{
        resource: 'stages',
        getStagesDuesReport(params = null) {
            return ApiService.get(`/${this.resource}/getStagesDuesReport`, params)
        },
    }
}
